import React from "react";


interface IFormResponse<Type> {
    values: Type;
    update: (key: string, value: any) => void;
    reset: (value?: string | Partial<Type>) => void;
}

const useState = <Type extends Record<string, any>>(initialValues: Type): IFormResponse<Type> => {
    const [values, setValues] = React.useState<Type>(initialValues);
  
    const handleUpdate = React.useCallback((key: string, value: any) => {
        setValues(prev => {
            return {
                ...prev,
                [key]: value
            };
        });
    }, []);

    const handleReset = React.useCallback((value?: string | Partial<Type>) => {
        if (value !== undefined) {
            if (typeof value === 'string') {
                handleUpdate(value, initialValues[value]);
                return;
            }

            setValues({
                ...initialValues,
                ...value
            });
            return;
        }
        
        setValues(initialValues);
        // eslint-disable-next-line
    }, []);
  
    return {
        values,
        update: handleUpdate,
        reset: handleReset,
    };
};
  
export default useState;